<template>
  <section class="b_features" id="company_services">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="title">
            <h3>БАЙГУУЛЛАГЫН ҮЙЛЧИЛГЭЭ</h3>
            <div class="underline"></div>
            <!-- <p>Сансрын технологид суурилсан байгууллагын үйлчилгээ</p> -->
          </div>
          <!--/.title-->
        </div>
        <div class="w-100"></div>
        <div class="col-md-4 wow animate fadeInUp">
          <div class="single_feature" v-on:click="openModal('network')">
            <div class="feature_icon">
              <a>
                <img src="../assets/img/icon/Network01.png" class="show_icon" />
              </a>
              <a>
                <img src="../assets/img/icon/Network02.png" class="hide_icon" />
              </a>
            </div>
            <!--/.single_feature-->
            <div class="feature_txt">
              <h4>Өндөр хурдны интернет</h4>
              <p>Байгууллагын интернетийн үйлчилгээ</p>
              <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Банк санхүү</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Уул уурхай</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Жуулчны бааз</span>
                </li>
              </ul>
            </div>
            <div class="line1"></div>
            <div class="line2"></div>
          </div>
          <!--/.single_feature-->
        </div>
        <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.2s">
          <div class="single_feature" v-on:click="openModal('operator')">
            <div class="feature_icon">
              <img src="../assets/img/icon/operator1.png" class="show_icon" alt />
              <img src="../assets/img/icon/operator2.png" class="hide_icon" alt />
            </div>
            <!--/.single_feature-->
            <div class="feature_txt">
              <h4>Үүрэн холбоо</h4>
              <p>Үүрэн холбооны сувгийн түрээсийн үйлчилгээ:</p>
              <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Гол шугамын холболт</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>5G</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Нөөц холболт</span>
                </li>
              </ul>
            </div>
            <div class="line1"></div>
            <div class="line2"></div>
          </div>
          <!--/.single_feature-->
        </div>
        <div class="col-md-4 wow animate fadeInUp" data-wow-delay="0.4s">
          <div class="single_feature" v-on:click="openModal('moving')">
            <div class="feature_icon">
              <img src="../assets/img/icon/move01.png" class="show_icon" alt />
              <img src="../assets/img/icon/move02.png" class="hide_icon" alt />
            </div>
            <!--/.single_feature-->
            <div class="feature_txt">
              <h4>Хөдөлгөөнт интернет</h4>
              <p>Хөдөлгөөнт обьектодуудыг өндөр хурдны интернет холбох үйлчилгээ:</p>
              <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Нислэгийн хөдөлгөөнт интернет</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Галт тэрэгний хөдөлгөөнт интернет</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Цэрэг арми, Онцгой байдлын холбоо</span>
                </li>
                <li style="margin-top: 5px; margin-bottom: 5px;">
                  <i class="fa fa-angle-double-right" style="color: #f26322;"></i>&nbsp;
                  <span>Аялалын хөдөлгөөнт интернет</span>
                </li>
              </ul>
            </div>
            <div class="line1"></div>
            <div class="line2"></div>
          </div>
          <!--/.single_feature-->
        </div>
        <mdb-container>
          <mdb-modal
            centered
            :show="product"
            class="product-modal"
            @close="product = false"
            size="lg"
            >
            <mdb-modal-header :style="{background: '#a5233b'}">
              <mdb-modal-title :style="{color: '#ffff'}">{{modelTitle}}</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>
              <mdb-row>
                <mdb-col lg="4">
                  <mdb-carousel
                    slide
                    :items="thumbnailCarousel"
                    controlls
                    indicators
                    :interval="5000"
                  ></mdb-carousel>
                </mdb-col>
                <mdb-col lg="8">
                  <mdb-tabs
                    :active="0"
                    tabs
                    card
                    class="mb-4"
                    color="indigo"
                    justify
                    :links="modalTabs"
                    :transition-duration="0.5"
                    transition-style="linear"
                  >
                    <template :slot="'bank'">
                      <p>Хиймэл дагуулын холбоогоор байгууллагын салбар хоорондын онлайн сүлжээг бий болгох. Төрийн болон хувийн хэвшил, бизнесийн болон Банк санхүүгийн байгууллагууд өөр хоорондоо эсвэл алслагдсан салбар нэгжүүдтэйгээ онлайн холболт үүсгэн мэдээлэл солилцох боломжийг ямар нэгэн нэмэлт төхөөрөмжийн шаардлагагүйгээр маш өндөр нууцлал (AES256)-тайгаар авах боломжыг олгодог.</p>
                    </template>

                    <template :slot="'mining'">
                      <p>Өндөр хурдны интернэт хэрэглэхийг хүссэн албан байгууллага, аж ахуйн нэгж, ард иргэдэд хиймэл дагуулын сүлжээ ашиглан орон зай, байршил, цаг хугацаанаас үл хамааран өндөр хурдны интернэт хүргэх үйлчилгээ юм.</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color: rgb(165, 35, 59);"></i>&nbsp;
                          <span>Хэрэглэгч өөрсдийн албан хүсэлтээр шаардлагатай үедээ үйлчилгээний хурдаа нэмэгдүүлж багасгах боломжтой (динамик)</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color: rgb(165, 35, 59);"></i>&nbsp;
                          <span>Орон зай, байршилаас үл хамаарсан найдвартай холболт</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color: rgb(165, 35, 59);"></i>&nbsp;
                          <span>Цаг агаарын ямар нэгэн таагүй нөхцөлд тасралтгүй холболт.</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color: rgb(165, 35, 59);"></i>&nbsp;
                          <span>Хэрэглэгч антенаа өөрсдөө шилжүүлэн суурилуулах боломжтой</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'vacation'">
                      <p>Мэдээлэл технологийн дэд бүтцээс алслагдсан жуулчны бааз, амралт сувилалын газрууд ашиглах боломжтой.</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Тоног төхөөрөмжөөр хангагдах</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Амрагчдад карт борлуулах /Орлого олох/</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Aмрагчид ашиглахад хялбар</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'mainline'">
                      <p>Манай хэрэглэгчийн төхөөрөмж(VSAT) нь 4G, 5G технологийг бүрэн дэмжиж ажиллах ба алслагдсан суурин газар дахь үүрэн холбооны бааз станц болон операторын төв хоорондын холболт хийн яриа, дата дамжуулах боломжтой.</p>
                    </template>
                    <template :slot="'wifi'">
                      <p>5G сүлжээ нь 4G-гээс 66 дахин хурдан ба бүрэн хэмжээний киног 6 минут татахын оронд 4 секундэд татна гэсэн үг.</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Өндөр хурд</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Хугацаа бага</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Уян хатан сүлжээний архитектур</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'resource'">
                      <p>Хиймэл дагуул дээр суурилсан үүрэн сүлжээний нөөц нь сүлжээний операторуудад олон давуу талыг өгдөг.</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Сүлжээний өндөр хурдны нөөцлөлт</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Суурин эсвэл хөдөлгөөнт газар дээр хурдан, зардал багатай байршуулах</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Газрын сүлжээнээс үл хамаарах холболт</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'plane'">
                      <p>Нислэгийн үед агаарын тээврийн зорчигчид газар дээрхтэй ижил түвшинд агаарт интернетийн холболтыг хүлээж авах боломж</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Өндөр үзүүлэлттэй модем - 400Mbps</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Тусдаа бүрэлдэхүүн хэсэгээр эсвэл бүрэн нэгтгэсэн терминал хэлбэрээр ашиглах боломжтой</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>24 × 7 NOC-ийн иж бүрэн үйлчилгээ, үйлчилгээний хугацааг түргэсгэж, хүртээмжийн өндөр түвшинд хангана</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'train'">
                      <p>Хүссэн үедээ, хүссэн цагтаа авах боломжтой галт тэрэгний өндөр хурдны интернетийн холболт</p>
                      <ul style="list-style-type: none; margin-left: 0; padding-left: 2em;">
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Хот хоорондын төмөр замын зорчигчдод зориулсан байнгын холболт</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Хонгил эсвэл цаг агаарын эрс тэс байдлаас үл хамааран найдвартай холболтыг ханган</span>
                        </li>
                        <li style="margin-top: 5px; margin-bottom: 5px;">
                          <i class="fa fa-angle-double-right" style="color:  rgb(165, 35, 59);"></i>&nbsp;
                          <span>Туннелийн хязгаарлалтыг давсан өндөр хүртээмжтэй интернетийн холболт</span>
                        </li>
                      </ul>
                    </template>
                    <template :slot="'army'">
                      <p>Овор хэмжээ багатай автомат болон механик байж болох зөвхөн Арми, хилийн цэрэг, онцгой байдлын хэрэгцээнд зориулагдсан үүрч алхах болон зөөвөрлөхөд хялбар сансрын холбооны төхөөрөмж юм. Тус зөөврийн төхөөрөмжийн тусламжтайгаар өндөр хурдны интернэт, телефоны үйлчилгээ болон онлайн холболтын үйлчилгээ авах боломжтой.</p>
                    </template>
                    <template :slot="'journey'">
                      <p>Овор хэмжээ багатай автомат болон механик байж болох аялалын тоног бүхий автомашин дээр суурилуулах боломжтой. Тус төхөөрөмжийн тусламжтайгаар өндөр хурдны интернэт, телефон болон телевизийн үйлчилгээ авах боломжтой.</p>
                    </template>
                  </mdb-tabs>
                  <mdb-card-body>
                    <div class="text-center">
                      <a class="fb-ic mr-3" role="button">                  
                        <mdb-icon fab icon="facebook-f" size="lg" style="color: rgb(165, 35, 59);" />
                      </a>
                      <a class="tw-ic mr-3" role="button">
                        <mdb-icon fab icon="twitter" size="lg"  style="color: rgb(165, 35, 59);"/>
                      </a>
                      <a class="yt-ic mr-3" role="button">
                        <mdb-icon fab icon="youtube" size="lg" style="color: rgb(165, 35, 59);" />
                      </a>
                    </div>
                  </mdb-card-body>
                </mdb-col>
              </mdb-row>
            </mdb-modal-body>
          </mdb-modal>
        </mdb-container>
      </div>
    </div>
    <!--/.container-->
  </section>
</template>

<script>
import {
  mdbModalHeader,
  mdbModalTitle,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbIcon,
  mdbTabs,
  mdbModal,
  mdbModalBody,
  mdbCardBody,
  mdbCarousel
} from "mdbvue";
export default {
  components: {
    mdbModalHeader,
    mdbModalTitle,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbTabs,
    mdbModal,
    mdbModalBody,
    mdbCardBody,
    mdbCarousel
  },
  data() {
    return {
      product: false,
      thumbnailCarousel: null,
      modelTitle: null,
      modalTabs: null,
      modalBody: null
    };
  },
  methods: {
    openModal(type) {
      this.product = !this.product;
      if (type == "network") {
        this.modelTitle = "Өндөр хурдны интернет";
        this.thumbnailCarousel = [
          {
            img: true,
            src: require("../assets/img/tabs/Bank.jpg"),
            alt: "First slide"
            // caption: {
            //   title: "First slide"
            // }
          },
          {
            img: true,
            src: require("../assets/img/tabs/Mining.jpg"),
            alt: "Second slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/Camp.jpg"),
            alt: "Thirth slide"
          }
        ];
        this.modalTabs = [
          {
            text: "Банк санхүү",
            icon: "university",
            bigIcon: true,
            slot: "bank",
            color: "danger"
          },
          {
            text: "Уул уурхай",
            icon: "industry",
            bigIcon: true,
            slot: "mining"
          },
          {
            text: "Жуулчны бааз",
            icon: "bed",
            bigIcon: true,
            slot: "vacation"
          }
        ];
      } else if (type == "operator") {
        this.modelTitle = "Үүрэн холбоо";
        this.thumbnailCarousel = [
          {
            img: true,
            src: require("../assets/img/tabs/Connection.jpg"),
            alt: "First slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/5G.jpg"),
            alt: "Second slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/Support.jpg"),
            alt: "Third slide"
          }
        ];
        this.modalTabs = [
          {
            text: "Гол шугамын холболт",
            icon: "plug",
            bigIcon: true,
            slot: "mainline"
          },
          { text: "5G", icon: "wifi", bigIcon: true, slot: "wifi" },
          {
            text: "Нөөц холболт",
            icon: "random",
            bigIcon: true,
            slot: "resource"
          }
        ];
      } else {
        this.modelTitle = "Хөдөлгөөнт интернет";
        this.thumbnailCarousel = [
          {
            img: true,
            src: require("../assets/img/tabs/Plane.jpg"),
            alt: "First slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/Train.jpg"),
            alt: "Second slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/Army.jpg"),
            alt: "Third slide"
          },
          {
            img: true,
            src: require("../assets/img/tabs/Mobility.jpg"),
            alt: "Fourth slide"
          }
        ];
        this.modalTabs = [
          { text: "Нислэг", icon: "plane", bigIcon: true, slot: "plane" },
          { text: "Галт тэрэг", icon: "train", bigIcon: true, slot: "train" },
          {
            text: "Цэрэг арми",
            icon: "fighter-jet",
            bigIcon: true,
            slot: "army"
          },
          { text: "Аялалын", icon: "suitcase", bigIcon: true, slot: "journey" }
        ];
      }
    }
  }
};
</script>